(function () {
  function replaceBuyItNowText() {
    document
      .querySelectorAll('.shopify-payment-button__button--unbranded')
      .forEach((btn) => {
        const t = (btn.textContent || '').trim().toLowerCase();
        if (t === 'buy it now') {
          btn.textContent = 'Pre-order';
          btn.setAttribute('aria-label', 'Pre-order');
        }
      });
  }

  // 1) intenta al cargar
  document.addEventListener('DOMContentLoaded', replaceBuyItNowText);

  // 2) Shopify lo re-renderiza: observer
  const obs = new MutationObserver(replaceBuyItNowText);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 3) “plan B”: reintenta unos segundos por si aparece tarde
  let tries = 0;
  const timer = setInterval(() => {
    replaceBuyItNowText();
    tries += 1;
    if (tries >= 30) clearInterval(timer); // ~6 segundos
  }, 200);
})();


(function () {
  function replaceAddToCartText() {
    // Common places: product page, featured product, quick add, mobile sticky add-to-cart
    const selectors = [
      'button[name="add"] span',                 // like your snippet <button ...><span>Add to cart</span>
      'button[name="add"]',
      '.product-form__submit span',
      '.product-form__submit',
      '.quick-add__submit',
      '.sticky-atc button',
      '.product-sticky-form button'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      // If it's a button, change its text only if it matches exactly
      const text = (el.textContent || '').trim().toLowerCase();

      if (text === 'add to cart') {
        el.textContent = 'Pre-order';
        el.setAttribute?.('aria-label', 'Pre-order');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', replaceAddToCartText);
  const obs2 = new MutationObserver(replaceAddToCartText);
  obs2.observe(document.documentElement, { childList: true, subtree: true });

  // retry briefly for late-rendered mobile sections
  let tries = 0;
  const t = setInterval(() => {
    replaceAddToCartText();
    tries += 1;
    if (tries >= 30) clearInterval(t);
  }, 200);
})();


// --- EXTRA: Collection card hover / quick-add "ADD TO CART" -> "Pre-order" ---
function replaceCardAddToCartText() {
  const targets = document.querySelectorAll([
    // common quick-add buttons on collection cards
    '.quick-add__submit',
    '.card__content button',
    '.card__content .button',
    '.product-card button',
    '.product-card .button',
    '.grid-product__add-to-cart',
    // sometimes it's an input submit with value="ADD TO CART"
    'input[type="submit"]',
    'input[type="button"]'
  ].join(','));

  targets.forEach((el) => {
    // 1) If it's an input button, text is in value=""
    if (el.tagName === 'INPUT') {
      const v = (el.value || '').trim().toLowerCase();
      if (v === 'add to cart' || v === 'add to bag' || v === 'add to basket') {
        el.value = 'Pre-order';
        el.setAttribute('aria-label', 'Pre-order');
      }
      return;
    }

    // 2) If it's a button/other element, text is in textContent
    const t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    // matches "ADD TO CART" too because we lower-case it
    if (t === 'add to cart' || t === 'add to bag' || t === 'add to basket') {
      el.textContent = 'Pre-order';
      el.setAttribute?.('aria-label', 'Pre-order');
    }

    // 3) Sometimes text sits in a child span
    const span = el.querySelector?.('span');
    if (span) {
      const st = (span.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (st === 'add to cart' || st === 'add to bag' || st === 'add to basket') {
        span.textContent = 'Pre-order';
        el.setAttribute?.('aria-label', 'Pre-order');
      }
    }
  });
}

// Run + keep it updated (hover / quick-add often renders late)
document.addEventListener('DOMContentLoaded', replaceCardAddToCartText);
const cardObs = new MutationObserver(replaceCardAddToCartText);
cardObs.observe(document.documentElement, { childList: true, subtree: true });

let cardTries = 0;
const cardTimer = setInterval(() => {
  replaceCardAddToCartText();
  cardTries += 1;
  if (cardTries >= 30) clearInterval(cardTimer);
}, 200);

